import React from 'react';

import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function SignatureQuestion({
  identifier, pages, info, handleDeleteQuestion,
  mode, handleDuplicateQuestion,
}) {
  const question = useQuestionForm({ identifier, pages, info });

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleVariant="welcomeTitle"
      titleKey="task.taskEdition.signatureQuestionText.question"
      descriptionKey="task.taskEdition.signatureQuestionText.description"
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    />
  );
}

export default SignatureQuestion;
